import axios from "axios";
import pkg from '../package.json';

export function requestAPI(method,uri,data=null,withToken=true){
    return new Promise((resolve,reject)=>{
        const token= localStorage.getItem('token');
        let headers = {
            headers:{
                Authorization:`Bearer ${token}`
            }
        }
        if(!withToken)headers={};
        axios({
            ...headers,
            method,
            url:pkg.api_url+uri,
            data,
        }).then(res=>{
            resolve(res.data);
        }).catch(e=>{
            console.log('RequestAPI Error',e);
            reject(e);
        })
    })
}

export function checkLogin(){
    return requestAPI('GET','/users/me');
}

export function login(email,password){
    return new Promise((resolve,reject)=>{
        axios.post(pkg.api_url+'/auth/local').then(res=>{
            resolve(res.data);
        }).catch(res=>{
            resolve(null);
        })
    })
}
